import { Injectable } from '@angular/core';
import { Breadcrumb } from './breadcrumb.model';
@Injectable()
export class BreadcrumbService {
  public routeFriendlyNames: Breadcrumb[] = [];

  public addFriendlyNameForRoute(route: string, name: string): void {
    let rte: Breadcrumb = new Breadcrumb(route, name);
    this.routeFriendlyNames.push(rte);
  }

  public getFriendlyNameForRoute(route: string): string {
    var resultName = '[' + route + ']';
    let rte = this.routeFriendlyNames.filter(item => item.routeUrl == route)[0];

    if (rte == undefined) {
      //see if there is a match without the last /segment in case its /{id}
      let parentRouteName: string = route.substr(0, route.lastIndexOf('/')); //drop any :id
      rte = this.routeFriendlyNames.filter(item => item.routeUrl == parentRouteName)[0];
    }

    if (rte != undefined) {
      resultName = rte.routeName;
    }

    return resultName;
  }
  public hasFriendlyNameForRoute(route: string): boolean {
    var result = false;
    let rte = this.routeFriendlyNames.filter(item => item.routeUrl == route)[0];

    if (rte != undefined) {
      result = true;
    }

    return result;
  }
}
